
import { useCallback, useReducer } from 'react'
import { Catalog } from '../models/catalog'
import { catalogReducer } from '../reducers/catalogReducer'

const initialState = {
    id_categoria_temp: null,
    catalog: [],
    categorias: [],
    catalogGroup: [],
}

export const useCatalog = () => {

    const [state, dispatch] = useReducer(catalogReducer, initialState)
    const { id_categoria_temp, catalog, categorias, catalogGroup } = state

    const initLoadCatalog = useCallback(async (filters = {}) => {
        const data = await Catalog.getAll(filters)
        const action = {
            type: '[CATALOG] Load list',
            payload: data
        }

        dispatch(action)

    }, [dispatch])

    const initLoadCatalogGroup = useCallback(async (filter) => {
        const data = await Catalog.getAllGroupByCategory(filter)

        const action = {
            type: '[CATALOG] Load list group',
            payload: data
        }

        dispatch(action)
    }, [])

    const initLoadCategorias = useCallback(async (filters) => {
        const data = await Catalog.getCategorias(filters)

        const action = {
            type: '[CATALOG] Load categorias',
            payload: data
        }

        dispatch(action)

    }, [])

    const handleNew = async (newServicio) => {
        const result = await Catalog.save(newServicio)

        if (result) {
            const updatedList = await Catalog.getAll({})
            const action = {
                type: '[CATALOG] Load list',
                payload: updatedList
            }

            dispatch(action)
        }

    }

    const handleUpdate = async (data, categorias) => {
        const result = await Catalog.update(data)

        const newCatalog = catalog.map(it => {
            if (it.id === data.id) {
                const newCategoria = categorias?.find(c => c.id === result.id_categoria)
                return {
                    ...it,
                    tipo: result.tipo,
                    servicio: result.nombre,
                    id_categoria: result.id_categoria,
                    categoria: newCategoria?.nombre || '',
                    descripcion: result.descripcion,
                    codigo: result.codigo,
                    precio_venta: result.precio_venta,
                    precio_costo: result.precio_costo,
                    total_utilidad: result.total_utilidad,
                    margen_utilidad: result.margen_utilidad
                }
            }

            return it
        })

        const action = {
            type: '[CATALOG] Load list',
            payload: newCatalog
        }

        dispatch(action)

    }

    const handleDisabled = (id) => {
        const action = {
            type: '[CATALOG] Disable',
            payload: id
        }

        dispatch(action)

    }

    const handleNewCat = async (newCat) => {
        const resultId = await Catalog.saveCat(newCat)

        if (resultId) {
            const updatedList = await Catalog.getAll({})

            const action = {
                type: '[CATALOG] Load list',
                payload: updatedList
            }

            dispatch(action)
        }

    }

    const handleUpdateCat = async (data) => {
        const result = await Catalog.updateCat(data)

        const newList = categorias.map(it => {
            if (it.id === result.id) {
                return {
                    ...it,
                    nombre: result.nombre,
                    tipo: result.tipo
                }
            }

            return it

        })

        const action = {
            type: '[CATALOG] Load categorias',
            payload: newList
        }

        dispatch(action)

    }

    const handleDeleteCat = async (id) => {
        const resultOK = await Catalog.deleteCat(id)
        if (resultOK) {
            const newCategorias = categorias.filter(it => it.id !== id)

            const action = {
                type: '[CATALOG] Load categorias',
                payload: newCategorias
            }

            dispatch(action)
        }

    }

    const initExport = async (filters) => {
        await Catalog.getExport(filters)
    }

    return {
        id_categoria_temp,
        catalog,
        categorias,
        catalogGroup,

        handleNew,
        handleUpdate,
        handleDisabled,

        handleNewCat,
        handleUpdateCat,
        initLoadCatalog,
        initLoadCategorias,
        handleDeleteCat,
        initExport,
        initLoadCatalogGroup,

        // initCheckAll
    }

}